module["exports"] = [
  "市",
  "区",
  "町",
  "村"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/address/city_suffix.js
// module id = 1585
// module chunks = 0